<template>
	<nav class="UserNav" v-if="user&&user.id" >

		<button v-bind:class="{user_state:1,open}" v-on:click="toggleNav" >
			<span class="icon">
				<UserIcon :user="user" />
			</span>
			<span class="details">
				<span class="name">{{ user.first_name }}</span>
			</span>
		</button>

		<ul class="user_options" v-if="open" >
			<!-- <li v-for="org in orgs" ><router-link :to="'/'+org.id">{{org.name}}</router-link></li>
			<li class="divide"></li> -->
			<li><router-link to="/orgs">Manage organisations</router-link></li>
			<li><router-link to="/settings">Edit profile</router-link></li>
			<li><router-link to="/logout">Logout</router-link></li>
		</ul>

		<div class="menu_closelayer" v-if="open" v-on:click="toggleNav" ></div>

	</nav>
</template>

<script>

	import { mapState , mapGetters } from 'vuex'
	import UserIcon from "../components/UserIcon.vue";

	export default {

		components : {
			UserIcon,
		},

		data() {
			return {
				open : false,
			};
		},

		computed : {
			...mapState('auth',[
						'user',
						'orgs',
			]),
		},

		watch : {
			'$route.path' : function(){
				this.open = false;
			}
		},

		methods: {
			toggleNav(){
				this.open = !this.open;
			},
		}
	}

</script>